import { CampService } from '../../shared/service/camp.service';
import { FormGroup} from '@angular/forms';
import { ICamp } from '../../shared/model/camp.model';
import { Observable } from 'rxjs';
import { HttpResponse } from '@angular/common/http';
import { SnackBarService } from '../../shared/service/snackbar.service';
import { AbstractCampOngletComponent, SaveViewValueModuleTypeEnum } from './abstract-camp-onglet.component';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { map } from 'rxjs/operators';
import { LocalCacheService } from '../../shared/service/local-cache.service';
import { AfterViewChecked, Directive } from '@angular/core';
import { HistoModificationService } from '../../shared/service/histo-modification.service';
import {
  CampCodeModulesEnum, CampModificationActionEnum,
  StatutAvisEnum,
  TypeCampEnum,
  TypeCampGroupEnum,
  TypeDossierEnum
} from '../../shared/constant/enum';
import { getCampAlertMessages } from '../../shared/util/camp-utils';
import {DdcMatDialogService} from "../../shared/service/ddc-mat-dialog.service";

@Directive()
export abstract class AbstractCampOngletCampFormComponent extends AbstractCampOngletComponent<ICamp> implements AfterViewChecked {

  public formAlreadySubmitted = false;

  TypeDossierEnum = TypeDossierEnum;
  TypeCampGroupEnum = TypeCampGroupEnum;
  TypeCampEnum = TypeCampEnum;
  getCampAlertMessages = getCampAlertMessages;

  protected constructor(
    protected campService: CampService,
    public moduleCode: string,
    public campForm: FormGroup,
    protected activatedRoute: ActivatedRoute,
    protected snackBarService: SnackBarService,
    protected histoModificationService: HistoModificationService,
    protected ddcMatDialogService?: DdcMatDialogService,
  ) {
    super(
      activatedRoute,
      snackBarService,
      histoModificationService,
      campService
    );
  }

  ngAfterViewChecked(): void {
    const inputFields = document.getElementsByTagName('input');
    if (inputFields && inputFields.length > 0) {
      for (let i = 0; i < inputFields.length; i++) {
        if (inputFields.item(i).type === 'number') {
          inputFields.item(i).min = '0';
          inputFields.item(i).oninput = (e: KeyboardEvent) => {
            if (isNaN(parseInt(e.key))) {
              return false;
            }
          }
        }
      }
    }
  }

  protected getViewValueChangesObservable(): Observable<any> {
    return this.campForm.valueChanges;
  }

  protected findServerValue(idCamp: number): Observable<HttpResponse<ICamp>> {
    return this.campService.findOneByIdAndModuleCode(idCamp, this.moduleCode).pipe(map(response => {
        return new HttpResponse({
          ...response,
          body: CampService.convertCampDateFromServer(response.body)
        });
      }
    ));
  }

  protected convertViewValueDateFromServer(viewValue: ICamp): ICamp {
    return CampService.convertCampDateFromServer(viewValue);
  }

  updateViewValue(viewValue: ICamp) {
    this.campForm.patchValue(viewValue);
    this.formAlreadySubmitted = false;
  }

  protected getModuleCacheLocalCacheKey(idCamp: number): string {
    return LocalCacheService.getCampLocalCacheKeyForOnglet(idCamp, this.moduleCode);
  }

  /**
   * Suppression des champs d'histo pour éviter ce genre d'erreur : "You must define a type for App\Entity\CampHistoriqueModification::$modificationJson"
   */
  protected getViewValue(): ICamp {
    const data = {
      ...this.localCacheValue.data
    } as any;
    delete data.histoCreation;
    delete data.histoDerniereModification;
    return _.assign({}, data, this.getViewRawValue());
  }

  openSaveModuleDialog(content: string, dbReglementationConfirme: boolean, codeModule?: string, statutAvisEnum?: string) {

    if(codeModule === CampCodeModulesEnum.MARIN
      && (statutAvisEnum === StatutAvisEnum.DELIVRE || statutAvisEnum === StatutAvisEnum.REFUSE)){

      this.ddcMatDialogService.openConfirmActionDialog({
        content: content,
        confirmText: 'Confirmer',
        cancelText: 'Annuler',
        confirmAction: () => this.save()
      });
    } else {
      this.save();
    }
  }

  save() {
    if (this.isViewValid()) {
      this.isSaving = true;
      const viewValue = this.getViewValue();
      this.saveViewValue(SaveViewValueModuleTypeEnum.Static, viewValue);
    } else {
      this.campForm.markAllAsTouched();
      this.snackBarService.showError('Il y a une erreur de saisie sur la page. Veuillez contrôler les informations saisies');
    }
    this.formAlreadySubmitted = true;
  }

  protected getViewRawValue(): ICamp {
    return this.campForm.getRawValue();
  }

  protected isViewValid(): boolean {
    return this.campForm && this.campForm.invalid !== true;
  }

  protected updateServerWithViewValue(viewValue: ICamp, modificationJson: object, action: CampModificationActionEnum): Observable<HttpResponse<ICamp>> {
    console.log({text: 'AbstractCampOngletCampFormComponent.updateServerWithViewValue', viewValue, modificationJson});
    return this.campService.updateByCampAndModuleCode(viewValue, modificationJson, this.moduleCode, action);
  }

  get currentCamp(): ICamp {
    return this.localCacheValue && this.localCacheValue.data;
  }

  get currentCampServerValue(): ICamp {
    return this.localCacheValue && this.localCacheValue.serverValue;
  }

  resetCampDeclaration() {
    this.isSaving = true;
    const viewValue = this.getViewValue();
    this.saveViewValue(SaveViewValueModuleTypeEnum.Static, viewValue, CampModificationActionEnum.REINITIALISATION);
  }
}
